import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=f48311ea&scoped=true&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=f48311ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48311ea",
  null
  
)

export default component.exports